/*
 * @Author: liuxiuting
 * @Date: 2023-08-15 14:21:13
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-04-17 11:06:58
 * @FilePath: \common-mediax\src\common\userPermission.js
 * @Description:
 *
 * Copyright (c) 2024 by 用户/公司名, All Rights Reserved.
 */
import * as apis from "../apis";

/**
 * 获取无权限菜单列表
 * @returns {Promise<*[]>}
 */
let  getNotRulePages = async ()=> {
  let rrLoginInfo = localStorage.getItem("rrLoginUserInfo")
  let loginInfo = localStorage.getItem("loginInfo")
  loginInfo = JSON.parse(loginInfo);
  //获取云雀和云端稿库权限信息
  let pageRules = loginInfo.roles[0].pages
  let rrRules = [], notRulePages = [];
  pageRules.forEach((item) => {
    if (
      item.indexOf('rr-') === 0 &&
      item !== 'rr-command-receiver'
    ) {
      rrRules.push(item)
    }
  })

  // 当没有配置RR地址的时候（默认是有的，需要服务手动清空） 需要剔除所有云端稿库模块的权限
  if(!window.PROJECT_CONFIG.MEDIARR_CORE) {
    return rrRules;
  }

  if (!rrLoginInfo) {
    //云雀中自动登录到云端稿库，在登录成功后直接自动登录，避免在跳转云端稿库子应用前调用影响子应用加载速度，此处同步调用，需要后续判断云端稿库权限
    try{
      let checkSum = await apis.MediaCloudGateway.getAutologinChecksum()
      if (checkSum.data.status === 0) {
        let autoLogin = await apis.MediaCloudGateway.autoLoginRR({
          headers: {
            'Content-Type': 'text/html'
          },
          data: checkSum.data.data.checksum,
          timeout: 2000,  // 2s超时是为了如果出现云端稿库接口过慢 或者服务没有在没部署云端稿库时 手动清理云端稿库配置时 避免页面加载过慢
          closeErrorMsg: true
        })
        if(autoLogin.data.status === 0 && autoLogin.data.data){
          localStorage.setItem(
            'rrLoginUserInfo',
            JSON.stringify(autoLogin.data.data)
          )
        }else{
          return rrRules;
        }

        rrLoginInfo = autoLogin.data.data
      }
    }catch (e) {
      // console.log(e, 'rrRules::', rrRules);
      return rrRules
    }

  } else {
    rrLoginInfo = JSON.parse(rrLoginInfo);
  }

  rrRules.forEach((item) => {
    if (rrLoginInfo.roles[0].pages.indexOf(item) < 0) {
      //判断是否存在云端稿库权限中，
      notRulePages.push(item)
    }
  })
  return notRulePages
}
export default {
  getNotRulePages
}
